(function () {
  const defaultEnjoyContent = {
    pack: {
      kicker: 'EVERYDAY',
      title: 'Pack it for later',
      copy: 'Keep an individually wrapped square in your work bag, gym bag or car for an easy shelf-stable snack.'
    },
    pair: {
      kicker: 'A SIMPLE PAIRING',
      title: 'Pair it with coffee',
      copy: 'The honeyed peanut flavour and crisp texture make a satisfying companion to a morning coffee or afternoon tea.'
    },
    crumble: {
      kicker: 'MAKE IT A TOPPING',
      title: 'Crumble it over yogurt',
      copy: 'Break a square over yogurt or a smoothie bowl when you want extra crunch, flavour and 10 g of protein.'
    }
  };

  function initElitePdp(root) {
    if (!root || root.dataset.elite2Ready === 'true') return;
    root.dataset.elite2Ready = 'true';
    document.body.classList.add('elite2-page');

    const enjoyContent = {
      ...defaultEnjoyContent,
      pair: {
        ...defaultEnjoyContent.pair,
        copy: root.dataset.elite2PairCopy || defaultEnjoyContent.pair.copy
      }
    };

    const quantityInputs = Array.from(root.querySelectorAll('[data-elite2-quantity]'));
    const formQuantity = root.querySelector('[data-elite2-form-quantity]');
    const selection = root.querySelector('[data-elite2-selection]');
    const atcButton = root.querySelector('.elite2-atc');
    const atcCopy = root.querySelector('[data-elite2-atc-copy]');
    const heroPrice = root.querySelector('.elite2-price > strong');
    const heroUnitPrice = root.querySelector('.elite2-price > span');
    const stickyPrice = root.querySelector('[data-elite2-sticky-label]');
    const stickyQuantity = root.querySelector('[data-elite2-sticky-quantity]');

    quantityInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        const quantity = Number(input.value || 1);
        const boxLabel = quantity === 1 ? 'box' : 'boxes';
        const squareCount = input.dataset.squares || '';
        const total = input.dataset.total || '';
        const perSquare = input.dataset.perSquare || '';

        quantityInputs.forEach((option) => {
          option.closest('.elite2-tier')?.classList.toggle('is-selected', option === input);
        });
        if (formQuantity) formQuantity.value = String(quantity);
        if (selection) selection.textContent = `${quantity} ${boxLabel} · ${squareCount} squares · ${perSquare} each`;
        if (heroPrice) heroPrice.textContent = total;
        if (heroUnitPrice) heroUnitPrice.innerHTML = `${squareCount} squares · <b>${perSquare}</b> each`;
        if (stickyPrice) stickyPrice.textContent = total;
        if (stickyQuantity) stickyQuantity.textContent = `${quantity} ${boxLabel.toUpperCase()}`;
        if (atcCopy && !atcButton?.disabled) atcCopy.textContent = `ADD ${quantity} ${boxLabel.toUpperCase()} TO CART · ${total}`;
        if (atcButton && !atcButton.disabled) atcButton.setAttribute('aria-label', `Add ${quantity} ${boxLabel} to cart for ${total}`);
      });
    });

    const gallery = root.querySelector('[data-elite2-gallery]');
    const galleryTrack = root.querySelector('[data-elite2-gallery-track]');
    const slides = Array.from(root.querySelectorAll('[data-elite2-gallery-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-elite2-gallery-thumb]'));
    const galleryStatus = root.querySelector('[data-elite2-gallery-status]');
    let scrollFrame = null;

    function setGalleryIndex(index) {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === safeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      if (galleryStatus) galleryStatus.textContent = `${safeIndex + 1} / ${slides.length}`;
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.elite2GalleryThumb || 0);
        slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setGalleryIndex(index);
      });
    });

    galleryTrack?.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const width = galleryTrack.clientWidth || 1;
        setGalleryIndex(Math.round(galleryTrack.scrollLeft / width));
      });
    }, { passive: true });

    if (gallery && slides.length < 2) gallery.querySelector('.elite2-gallery__footer')?.setAttribute('hidden', '');

    const enjoyTabs = Array.from(root.querySelectorAll('[data-elite2-enjoy-tab]'));
    const enjoyPanel = root.querySelector('[data-elite2-enjoy-panel]');
    const enjoyKicker = root.querySelector('[data-elite2-enjoy-kicker]');
    const enjoyTitle = root.querySelector('[data-elite2-enjoy-title]');
    const enjoyCopy = root.querySelector('[data-elite2-enjoy-copy]');

    enjoyTabs.forEach((tab, index) => { tab.tabIndex = index === 0 ? 0 : -1; });

    enjoyTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        const content = enjoyContent[tab.dataset.elite2EnjoyTab];
        if (!content) return;
        enjoyTabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        enjoyPanel?.setAttribute('aria-labelledby', tab.id);
        if (enjoyKicker) enjoyKicker.textContent = content.kicker;
        if (enjoyTitle) enjoyTitle.textContent = content.title;
        if (enjoyCopy) enjoyCopy.textContent = content.copy;
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          enjoyPanel?.animate(
            [{ opacity: 0.65, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 220, easing: 'ease-out' }
          );
        }
      });
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % enjoyTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + enjoyTabs.length) % enjoyTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = enjoyTabs.length - 1;
        enjoyTabs[nextIndex]?.focus();
        enjoyTabs[nextIndex]?.click();
      });
    });

    const benefitTabs = Array.from(root.querySelectorAll('[data-elite2-benefit-tab]'));
    const benefitPanels = Array.from(root.querySelectorAll('[data-elite2-benefit-panel]'));

    function activateBenefit(tab) {
      const target = tab?.dataset.elite2BenefitTab;
      if (!target) return;
      benefitTabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      benefitPanels.forEach((panel) => {
        const active = panel.dataset.elite2BenefitPanel === target;
        panel.hidden = !active;
        if (active && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panel.animate(
            [{ opacity: 0.6, transform: 'translateY(7px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 230, easing: 'ease-out' }
          );
        }
      });
    }

    benefitTabs.forEach((tab, index) => {
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.addEventListener('click', () => activateBenefit(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % benefitTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + benefitTabs.length) % benefitTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = benefitTabs.length - 1;
        benefitTabs[nextIndex]?.focus();
        activateBenefit(benefitTabs[nextIndex]);
      });
    });

    const sticky = root.querySelector('[data-elite2-sticky]');
    const stickySubmit = root.querySelector('[data-elite2-sticky-submit]');
    const productForm = root.querySelector('form[data-type="add-to-cart-form"]');
    stickySubmit?.addEventListener('click', () => productForm?.requestSubmit());

    if (sticky && atcButton && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver((entries) => {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          sticky.classList.remove('is-visible');
          document.body.classList.remove('elite2-sticky-active');
          return;
        }
        const visible = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', visible);
        document.body.classList.toggle('elite2-sticky-active', visible);
      }, { threshold: 0.1 });
      stickyObserver.observe(atcButton);
    }

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      root.classList.add('has-reveals');
      const reveals = Array.from(root.querySelectorAll('.elite2-reveal'));
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach((element) => revealObserver.observe(element));
    }
  }

  function initAll() {
    document.querySelectorAll('[data-elite2-root]').forEach(initElitePdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initElitePdp(event.target.querySelector('[data-elite2-root]'));
  });
})();
